<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>书籍分类</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div class="container">
      <div class="classify-box">
        <div class="top-btn">
          <el-button
            type="primary"
            icon="el-icon-plus"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('672') : false
            "
            @click="addClassify"
            >添加书籍分类</el-button
          >
        </div>

        <div class="classify-table">
          <el-table
            ref="classifyTableRef"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              align="center"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
            >
            </el-table-column>
            <el-table-column label="操作" width="auto" align="center">
              <template slot-scope="scope">
                <el-button
                  @click="classifyEdit(scope.row)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('673')
                      : false
                  "
                  size="medium"
                  >修改</el-button
                >

                <el-button
                  @click="classifyDel(scope.row.category_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('674')
                      : false
                  "
                  size="medium"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <!-- 添加/编辑 -->
    <el-dialog
      :title="getDialogTitle"
      width="360px"
      center
      custom-class="classify-dialog"
      :visible.sync="dialogClassify"
    >
      <div style="padding: 20px">
        <el-input
          v-model="category_name"
          placeholder="请输入8个字以内"
          maxlength="8"
          style="width: 300px"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClassify = false" size="medium" plain
          >取 消</el-button
        >
        <el-button type="primary" @click="submit()" size="medium"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogTitle: 0,
      dialogClassify: false,
      category_name: '',
      category_id: '',
      tableHeader: [
        {
          label: '分类名称',
          prop: 'category_name',
          width: 'auto'
        }
      ],
      tableData: []
    };
  },
  filters: {},
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    getDialogTitle() {
      return this.dialogTitle == 0 ? '添加书籍分类' : '修改书籍分类';
    }
  },
  created() {
    this.getList();
  },
  methods: {
    //添加分类
    addClassify() {
      this.dialogTitle = 0;
      this.category_name = '';
      this.dialogClassify = true;
    },
    //修改分类
    classifyEdit(row) {
      this.category_name = row.category_name;
      this.category_id = row.category_id;
      this.dialogTitle = 1;
      this.dialogClassify = true;
    },
    //删除分类
    classifyDel(category_id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.axios
          .post('platform/library/deleteBookCategoryInfo', { category_id })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
      });
    },
    //保存
    submit() {
      let data = {
        category_name: this.category_name
      };
      let url = 'platform/library/saveBookCategoryInfo';
      if (this.dialogTitle == 1) {
        data.category_id = this.category_id;
        url = 'platform/library/editBookCategoryInfo';
      }
      this.axios.post(url, data).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功');
          this.dialogClassify = false;
          this.getList();
        }
      });
    },
    // 获取列表
    getList() {
      this.axios.post('platform/library/getBookCategoryList').then((res) => {
        this.tableData = res.data.list;
      });
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  border-radius: 5px;
  .classify-box {
    min-height: calc(100vh - 120px);
    background: #fff;
    padding: 20px;
    .top-btn {
      text-align: left;
      margin-bottom: 20px;
    }
    .classify-table {
      border: solid 1px #c9cbd6;
      width: 600px;
      .el-table {
        min-width: 600px;
      }
    }
  }
}
.classify-dialog {
  border-radius: 10px;
  .el-dialog__body {
    .el-form-item {
      margin-top: 20px;
      label {
        font-size: 16px;
      }
      .el-form-item__content {
        width: 60%;
      }
    }
  }
}
</style>